'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Immutable = require('Immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  start: null,
  end: null
};

function convertToMinutes(timestamp) {
  return Math.floor(timestamp / 60000);
}

function convertToMilliseconds(timestamp) {
  return timestamp * 60000;
}

var TimeRange = function (_Record) {
  _inherits(TimeRange, _Record);

  function TimeRange() {
    _classCallCheck(this, TimeRange);

    return _possibleConstructorReturn(this, (TimeRange.__proto__ || Object.getPrototypeOf(TimeRange)).apply(this, arguments));
  }

  _createClass(TimeRange, [{
    key: 'toBlocks',
    value: function toBlocks(duration /* number */) {
      var _this2 = this;

      return (0, _Immutable.Range)(0, Math.floor(this.duration() / duration)).map(function (i) {
        return TimeRange.from({
          start: _this2.start + i * duration,
          end: _this2.start + (i + 1) * duration
        });
      });
    }
  }, {
    key: 'toMinutes',
    value: function toMinutes() {
      if (!this.isInMinutes()) {
        return TimeRange.from({
          start: convertToMinutes(this.start),
          end: convertToMinutes(this.end)
        });
      }

      return this;
    }
  }, {
    key: 'toMilliseconds',
    value: function toMilliseconds() {
      if (!this.isInMilliseconds()) {
        return TimeRange.from({
          start: convertToMilliseconds(this.start),
          end: convertToMilliseconds(this.end)
        });
      }

      return this;
    }
  }, {
    key: 'isInMilliseconds',
    value: function isInMilliseconds() {
      var FIFTEEN_MINUTE_DURATION = _I18n2.default.moment.duration({ minutes: 15 }).asMilliseconds();
      return Math.floor(this.end / FIFTEEN_MINUTE_DURATION) >= 1;
    }
  }, {
    key: 'isInMinutes',
    value: function isInMinutes() {
      var DAY_DURATION_MINUTES = _I18n2.default.moment.duration({ hours: 24 }).asMinutes();
      return Math.floor(this.end / DAY_DURATION_MINUTES) <= 1;
    }
  }, {
    key: 'isValidTimeRange',
    value: function isValidTimeRange() {
      return (0, _Immutable.List)([_typeof(this.start), _typeof(this.end)]).every(function (t) {
        return t === 'number';
      });
    }
  }, {
    key: 'duration',
    value: function duration() {
      return this.end - this.start;
    }
  }, {
    key: 'contain',
    value: function contain(time /* Time */) {
      return Math.max(Math.min(time, this.end - 1), this.start);
    }
  }, {
    key: 'timeToOffsetFloat',
    value: function timeToOffsetFloat(time /* Time */) {
      return (time - this.start) / this.duration();
    }
  }, {
    key: 'isEqual',
    value: function isEqual(dtr /* TimeRange */) {
      return this.start === dtr.start && this.end === dtr.end;
    }
  }, {
    key: 'hasIntersection',
    value: function hasIntersection(dtr /* TimeRange */) {
      return this.start < dtr.end && this.end > dtr.start;
    }
  }, {
    key: 'contains',
    value: function contains(time /* Time */) {
      return this.start <= time && this.end > time;
    }
  }, {
    key: 'pushBack',
    value: function pushBack(duration /* number */) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end - duration
      });
    }
  }, {
    key: 'subtractStart',
    value: function subtractStart(duration /* number */) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end
      });
    }
  }, {
    key: 'subtractEnd',
    value: function subtractEnd(duration /* number */) {
      return TimeRange.from({
        start: this.start,
        end: this.end - duration
      });
    }
  }, {
    key: 'union',
    value: function union(dtr /* TimeRange */) {
      if (!this.hasIntersection(dtr)) return (0, _Immutable.List)([this, dtr]);

      return (0, _Immutable.List)([TimeRange.from({
        start: Math.min(this.start, dtr.start),
        end: Math.max(this.end, dtr.end)
      })]);
    }
  }, {
    key: 'intersect',
    value: function intersect(dtr /* TimeRange */) {
      if (!this.hasIntersection(dtr)) return null;
      return TimeRange.from({
        start: Math.max(this.start, dtr.start),
        end: Math.min(this.end, dtr.end)
      });
    }
  }, {
    key: 'clipEnd',
    value: function clipEnd(edge /* Time */) {
      if (edge < this.start) return null;
      return TimeRange.from({
        start: Math.min(edge, this.start),
        end: Math.min(edge, this.end)
      });
    }
  }, {
    key: 'clipStart',
    value: function clipStart(edge /* Time */) {
      if (edge > this.end) return null;
      return TimeRange.from({
        start: Math.max(edge, this.start),
        end: Math.max(edge, this.end)
      });
    }
  }], [{
    key: 'from',
    value: function from(json) {
      return new TimeRange(json);
    }
  }]);

  return TimeRange;
}((0, _Immutable.Record)(defaults));

exports.default = TimeRange;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/TimeRange.js
// module id = 30
// module chunks = 0